import template from './todo-group-table.pug';

export const TodoGroupTableComponent = {
  template,
  bindings: {
    groups: '<'
  },
  controller: class TodoGroupTableComponent {
    constructor(Todo, $async, $log, AlertBox) {
      'ngInject';
      this.Todo = Todo;
      this.$log = $log;
      this.AlertBox = AlertBox;
      this.updatePosition = $async(this.updatePosition.bind(this));
      this.edit = $async(this.edit.bind(this));
      this.delete= $async(this.delete.bind(this));
      this.fetch = $async(this.fetch.bind(this));


      this.sortableOptions = {
        handle: '.sortableListHandle',
        tolerance: 'pointer',
        stop: () => {
          this.groups.forEach((value, index) => {
            value.position = index + 1;
          });
        },
        update: (_e, ui) => {
          const position = ui.item.sortable.dropindex + 1;
          const id = ui.item.sortable.model.id;
          this.updatePosition(id, position);
        },
        axis: 'y'
      };
    }

    $onInit() {
      this.fetch();
    }

    async fetch() {
      try {
        this.loader = true;
        this.groups = await this.Todo.getGroups();
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }

    async updatePosition(id, position) {
      try {
        await this.Todo.updateGroupPosition(id, position);
        this.AlertBox.addMessage('alert.updated', { type: 'success' });
      } catch (e) {
        this.$log.error(e);
      }
    }

    async edit(group) {
      try {
        await this.Todo.groupModal(group);
        this.fetch();
      } catch (e) {
        this.$log.error(e);
      }
    }

    async delete(group) {
      const result = await this.AlertBox.confirm('confirmation_messages.delete', { type: 'warning' });

      if (result && result.value) {
        try {
          await this.Todo.deleteGroup(group.id);
          this.fetch();
        } catch (e) {
          this.$log.error(e);
        }
      }
    }

    async newGroup() {
      try {
        this.loader = true;
        const group = await this.Todo.groupModal();
        group.position = this.groups.length + 2;
        this.groups.push(group);
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }
  }
};
